import get from 'lodash.get';

const getContent = (state) => {
  const content = get(state, 'content');
  return content;
};

export default { getContent };
